import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';
import { ApiResponse, SteamApp } from './items.entity';

@Injectable({
  providedIn: 'root'
})
export class CacheBurstService extends AbstractService {
  constructor() {
    super();
    this.prefix = environment.cdnPath.replace(/\/$/, '');
  }

  getItems(appId: SteamApp, noCache = false): Observable<ApiResponse.ItemsList> {
    return this.get<ApiResponse.ItemsList>(`/items/${ appId }.json${ noCache ? `?cache-burst=${ Date.now() }` : '' }`);
  }
}